<template>
	<QrcodeNavLinkShell
		:data="data"
		:editable="editable"
		:active="active"
		:h5="h5"
		@select="$emit('select')"
	/>
</template>

<script>
	import QrcodeNavLinkShell from '../shared/QrcodeNavLinkShell.vue';
	import { qrcodeNavMixin } from '../shared/mixin.js';

	export default {
		name: 'GBlockQrcodeNavLink',
		components: { QrcodeNavLinkShell },
		mixins: [qrcodeNavMixin],
	};
</script>
